import { trimsConstants } from "../../constants";
import { trimsService } from "../../services";
import { alertActions } from "../alert.actions";

export const trimsActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    trimsService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: trimsConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: trimsConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: trimsConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, chinese_name, status) {
  return (dispatch) => {
    dispatch(request(name, chinese_name, status));

    trimsService.addParameter(name, chinese_name, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: trimsConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: trimsConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: trimsConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, chinese_name, status) {
  return (dispatch) => {
    dispatch(request(id, name, chinese_name, status));

    trimsService.updateParameter(id, name, chinese_name, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: trimsConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: trimsConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: trimsConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    trimsService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: trimsConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: trimsConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: trimsConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: trimsConstants.CLEAR };
}
